import React, { useEffect, useState } from 'react'
import { Search} from 'lucide-react';


const ViewCandidate = () => {
    // const [activeTab, setActiveTab] = useState('candidates');
    const [registrations, setRegistrations] = useState([]);

  useEffect(() => {
    fetch("/api/dashboard")
      .then((res) => res.json())
      .then((data) => setRegistrations(data))
      .catch((err) => console.error("Error fetching registrations:", err));
  }, []);
      
      const [searchTerm, setSearchTerm] = useState('');
      const filteredRegistrations = registrations.filter(candidate =>
        candidate.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        candidate.role.toLowerCase().includes(searchTerm.toLowerCase()) ||
        candidate.highest_qualification.toLowerCase().includes(searchTerm.toLowerCase())
      );
      
      
  return (
    <div className="bg-white shadow-lg rounded-xl p-8 max-w-full">
    {/* Header with title and add button */}
    <div className="flex justify-between items-center mb-8 ">
      <h2 className="text-2xl font-bold text-gray-900">Candidate Details</h2>
    </div>
    
    {/* Search bar */}
    <div className="mb-8">
      <div className="relative rounded-lg shadow-sm">
        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
          <Search className="h-5 w-5 text-gray-400" />
        </div>
        <input
          type="text"
          placeholder="Search candidates by name, skills or status..."
          className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-12 py-3 text-gray-700 border border-gray-300 rounded-lg"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
    </div>
    
    {/* Candidates Table */}
    <div className="overflow-hidden shadow-md ring-1 ring-black ring-opacity-5 rounded-xl">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Name</th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">DOB</th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Phone</th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Email</th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Role</th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Qualification</th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">College</th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Branch</th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">University ID</th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">LinkedIn</th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">PDF</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {filteredRegistrations.length > 0 ? (
                filteredRegistrations.map((candidate) => (
                <tr key={candidate.id} className="hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center space-x-3">
                      <div className="text-sm font-medium text-gray-900">{candidate.name}</div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{candidate.date_of_birth}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{candidate.phone_number}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{candidate.email_id}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                      {candidate.role}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{candidate.highest_qualification}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{candidate.college_name}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{candidate.branch_name}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">{candidate.university_id}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <a 
                      href={candidate.linkedin_id} 
                      target="_blank" 
                      rel="noreferrer"
                      className="text-indigo-600 hover:text-indigo-900 flex items-center"
                    >
                      {candidate.linkedin_id} 
                    </a>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <a 
                      href={`/uploads/${candidate.attachment}`} 
                      target="_blank" 
                      rel="noreferrer"
                      className="text-indigo-600 hover:text-indigo-900 flex items-center"
                    >
                      <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                        <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
                      </svg>
                      View PDF
                    </a>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" className="px-6 py-12 text-center">
                  <div className="flex flex-col items-center">
                    <Search className="h-12 w-12 text-gray-300 mb-4" />
                    <p className="text-gray-500 font-medium">No candidates found</p>
                    <p className="text-sm text-gray-400 mt-2">Try adjusting your search criteria</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  </div>
  )
}

export default ViewCandidate